// import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
// import React from 'react'


// function createData(
//     name: string,
//     calories: number,
//     fat: number,
//     carbs: number,
    
//   ) {
//     return { name, calories, fat, carbs };
//   }
  
//   const rows = [
//     createData('Frozen yoghurt', 159, 6.0, 24),
//     createData('Ice cream sandwich', 237, 9.0, 37),
  

//   ];

// const CustomOrderLivereur = () => {
//   return (
//    <TableContainer component={Paper}>
//       <Table sx={{ minWidth: 650 }} aria-label="simple table">
//         <TableHead>
//           <TableRow>
//             <TableCell>Dessert (100g serving)</TableCell>
//             <TableCell align="right">Calories</TableCell>
//             <TableCell align="right">Fat&nbsp;(g)</TableCell>
//             <TableCell align="right">Carbs&nbsp;(g)</TableCell>

//           </TableRow>
//         </TableHead>
//         <TableBody>
//           {rows.map((row) => (
//             <TableRow
//               key={row.name}
//               sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
//             >
//               <TableCell component="th" scope="row">
//                 {row.name}
//               </TableCell>
//               <TableCell align="right">{row.calories}</TableCell>
//               <TableCell align="right">{row.fat}</TableCell>
//               <TableCell align="right">{row.carbs}</TableCell>
          
//             </TableRow>
//           ))}
//         </TableBody>
//       </Table>
//     </TableContainer>
//   )
// }

// export default CustomOrderLivereur

import React from "react";
import { List, ListItem, ListItemText } from "@mui/material";

interface ChauffeurCamion {
  FullName: string;
  PhoneNumber: string;
  NumeroCamion: string;
}

interface CustomOrderLivereurProps {
  chauffeurs: ChauffeurCamion[];
}

const CustomOrderLivereur: React.FC<CustomOrderLivereurProps> = ({ chauffeurs }) => {
  return (
    <List>
      {chauffeurs.map((chauffeur, index) => (
        <ListItem key={index}>
          <ListItemText primary={`${chauffeur.FullName} - ${chauffeur.PhoneNumber}`} secondary={`Camion: ${chauffeur.NumeroCamion}`} />
        </ListItem>
      ))}
    </List>
  );
};

export default CustomOrderLivereur;
